import {
	AG_DEFAULT_COL_DEF,
	AG_HEADER_HEIGHT,
	AG_ROW_HEIGHT,
	AG_STATUS_BAR_TOTAL_FILTERED,
} from "@/utils/ag-grid-defaults";
import {
	Button,
	Grid,
	InputAdornment,
	TextField,
	Typography,
} from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { CreateWorker } from "../CreateWorker/ModalCreateWorker";
import { DeleteWorker } from "../DeleteWorker/ModalDeleteWorker";
import { EditWorker } from "../EditWorker/ModalEditWorker";
import { useTableData } from "./customHooks/useTableData";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		relative: {
			position: "relative",
		},
		btnModal: {
			display: "flex",
			justifyContent: "flex-end",
		},
	}),
);

type Props = {
	isLoading: boolean;
	getWorkersFromAPI: Function;
};

export const TableWorkers = ({ isLoading, getWorkersFromAPI }: Props) => {
	const [modalCreateActive, setModalCreateActive] = useState(false);
	const [modalEditDataWorker, setModalEditDataWorker] = useState(false);
	const [modalDeleteWorker, setModalDeleteWorker] = useState(false);

	const [workerIdForEdit, setWorkerIdForEdit] = useState<number | null>(null);
	const [workerIdForDelete, setWorkerIdForDelete] = useState<number | null>(
		null,
	);

	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);
	const [filterInput, setFilterInput] = useState("");

	const classes = useStyles();

	const { rows, columns } = useTableData({
		setWorkerIdForEdit,
		setModalEditDataWorker,
		setWorkerIdForDelete,
		setModalDeleteWorker,
	});

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
		params.api.sizeColumnsToFit();
	};

	useEffect(() => {
		gridAPI?.setQuickFilter(filterInput);
	}, [filterInput, gridAPI]);

	useEffect(() => {
		if (!gridAPI) return;
		if (isLoading) gridAPI.showLoadingOverlay();
		else if (rows.length === 0) gridAPI.showNoRowsOverlay();
		else gridAPI.hideOverlay();
	}, [isLoading, gridAPI, rows.length]);

	return (
		<Grid container justifyContent="center">
			<Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
				<Typography
					variant="h5"
					style={{ margin: "10px 0 6px", fontWeight: 600 }}
				>
					Workers Management
				</Typography>
			</Grid>
			<Grid container justifyContent="center" alignItems="center">
				<Grid
					item
					md={12}
					xs={12}
					style={{ padding: "0 15px" }}
					className={classes.relative}
				>
					<EditWorker
						show={modalEditDataWorker}
						workerIdForEdit={workerIdForEdit}
						onHide={(shouldUpdate: boolean) => {
							setModalEditDataWorker(false);
							setWorkerIdForEdit(null);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>
					<CreateWorker
						show={modalCreateActive}
						onHide={(shouldUpdate: boolean) => {
							setModalCreateActive(false);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>{" "}
					<DeleteWorker
						show={modalDeleteWorker}
						workerIdForDelete={workerIdForDelete}
						onHide={(shouldUpdate: boolean) => {
							setModalDeleteWorker(false);
							if (shouldUpdate) getWorkersFromAPI().then(() => {});
						}}
					/>

					<div style={{ display: "flex", gap: 16, padding: "10px 0" }}>
						<div style={{ flex: 1 }}>
							<TextField
								fullWidth
								label="Search"
								variant="outlined"
								size="small"
								margin="dense"
								value={filterInput}
								onChange={(event) => setFilterInput(event.target.value)}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<SearchIcon />
										</InputAdornment>
									),
								}}
							/>
						</div>
					</div>

					<div
						className="ag-theme-balham"
						style={{ width: "100%", height: "60vh" }}
					>
						<AgGridReact
							onGridReady={onGridReady}
							rowData={rows}
							columnDefs={columns}
							defaultColDef={AG_DEFAULT_COL_DEF}
							rowHeight={AG_ROW_HEIGHT}
							headerHeight={AG_HEADER_HEIGHT}
							animateRows={true}
							rowSelection="single"
							statusBar={AG_STATUS_BAR_TOTAL_FILTERED}
							getRowId={(params) => String(params.data.workerId)}
							overlayNoRowsTemplate='<span class="ag-overlay-no-rows-center">No workers yet</span>'
						/>
					</div>
					<Grid container justifyContent="flex-end">
						<Grid item md={2} xs={12} className={classes.btnModal}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => setModalCreateActive(!modalCreateActive)}
								fullWidth
								style={{ marginTop: 10 }}
							>
								New worker
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
